export default class AbstractNotifier {
    constructor(agent) {
        this.agent = agent;
    }

    get title() {
        throw new Error("getter 'title' must be implemented.");
    }

    get notificationTitle() {
        throw new Error("getter 'notificationTitle' must be implemented.");
    }

    isSelectable() {
        return false;
    }

    proposalProductPolicy() {
        throw new Error("Method 'proposalProductPolicy' must be implemented.");
    }

    canCancelProduct() {
        return false;
    }

    canImportProduct() {
        return false;
    }

    cancelProductConfirmMessage(agentProduct) {
        return `Weet je zeker dat je het product "${agentProduct.name}" wilt annuleren?`;
    }

    hasProductBooking() {
        return false;
    }

    productBookingUrl() {
        return null;
    }

    hasCancellationOptionalSending() {
        return false;
    }
}
